import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';

/**
 * Compact indicator for whether a user can receive push notifications
 * (i.e. has a registered push token). Helps decide who's worth notifying.
 */
const AudiencePushChip: React.FC<{ pushable: boolean }> = ({ pushable }) => {
  if (pushable) {
    return (
      <Tooltip title="Has a push token — can receive notifications">
        <Chip
          icon={<NotificationsActiveIcon sx={{ fontSize: 14 }} />}
          label="Push"
          size="small"
          color="success"
          variant="outlined"
          sx={{ height: 22, '& .MuiChip-label': { px: 0.75 } }}
        />
      </Tooltip>
    );
  }
  return (
    <Tooltip title="No push token — cannot receive notifications">
      <Chip
        icon={<NotificationsOffIcon sx={{ fontSize: 14 }} />}
        label="No push"
        size="small"
        variant="outlined"
        sx={{
          height: 22,
          color: 'text.disabled',
          borderColor: 'divider',
          '& .MuiChip-label': { px: 0.75 },
        }}
      />
    </Tooltip>
  );
};

export default AudiencePushChip;
